import React, { memo } from 'react';
import CommonSourceCard from '@gp/components/CommonSourceCard';
import LogoList from '@gp/pages/StudioDashboard/StudioOverall/components/LogoList';
import { getNumberOfDotUnit } from '@gp/utils/common';
import '@gp/pages/StudioDashboard/StudioOverall/components/MetricsCard2/index.scss';

const MetricsCard2: React.FC<IMetricsCard2Props> = (props) => {
  const { title, icon, value, logos, defaultLogo, getBubbleMsg, isModalShowItemDate, dateFormatter, ...restProps } = props;

  const isNoData = !value && !logos?.length;

  const renderCardContent = () => {
    return (
      <LogoList
        title={title}
        logos={logos || []}
        defaultLogo={defaultLogo}
        getBubbleMsg={getBubbleMsg}
        isModalShowItemDate={isModalShowItemDate}
        dateFormatter={dateFormatter}
      />
    );
  };

  return (
    // @ts-ignore
    <CommonSourceCard
      {...restProps}
      title={title}
      icon={icon}
      value={getNumberOfDotUnit(value)}
      isNoData={isNoData}
      isPercentage={false}
      slot={renderCardContent()}
    />
  );
};

export default memo(MetricsCard2);
